import { computed, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import {
  generateCommand,
  generateSingleEntity,
  generateReadModelFromEntity,
  generateEntitiesFromWorkflow,
  generateFieldExampleData,
  generateReadModelFromWorkflow,
  generateEntitiesFromDescription
} from '@/ai'

const usePrompts = () => {
  const { proxy } = getCurrentInstance()
  const store = useStore()
  const workflow = computed(() => store.state.workflow.workflow)
  const cardTypes = computed(() => store.state.cardTypes.cardTypes)

  const getEntitiesFromWorkflow = async () => {
    const abortController = new AbortController()

    return await generateEntitiesFromWorkflow({
      workflow: workflow.value,
      cardTypes: cardTypes.value,
      abortController
    })
  }

  const getEntitiesFromDescription = async (userDescription) => {
    const abortController = new AbortController()

    return await generateEntitiesFromDescription({
      workflow: workflow.value,
      cardTypes: cardTypes.value,
      userDescription,
      abortController
    })
  }

  const getReadModelFromWorkflow = async (eventId) => {
    if (!workflow.value.aiDescription) {
      proxy.$loadingState.stop()
      await store.dispatch('workflow/openWorkflowDescriptionDialog')
      return
    }

    const abortController = new AbortController()

    return await generateReadModelFromWorkflow({
      eventId,
      workflow: workflow.value,
      cardTypes: cardTypes.value,
      abortController
    })
  }

  const getReadModelFromEntity = async (eventId, entity) => {
    if (!workflow.value.aiDescription) {
      proxy.$loadingState.stop()
      await store.dispatch('workflow/openWorkflowDescriptionDialog')
      return
    }

    const abortController = new AbortController()

    return await generateReadModelFromEntity({
      eventId,
      workflow: workflow.value,
      entity,
      cardTypes: cardTypes.value,
      abortController
    })
  }

  const getCommand = async (eventId) => {
    if (!workflow.value.aiDescription) {
      proxy.$loadingState.stop()
      await store.dispatch('workflow/openWorkflowDescriptionDialog')
      return
    }

    const abortController = new AbortController()

    return await generateCommand({
      eventId,
      workflow: workflow.value,
      cardTypes: cardTypes.value,
      abortController
    })
  }

  const getSingleEntity = async (name, entityDescription) => {
    const abortController = new AbortController()

    return await generateSingleEntity({
      workflow: workflow.value,
      cardTypes: cardTypes.value,
      name,
      entityDescription,
      abortController
    })
  }

  const getFieldExampleData = async (entity, field) => {
    const abortController = new AbortController()

    return await generateFieldExampleData({
      aiVersion: workflow.value.aiVersion,
      entity,
      field,
      abortController
    })
  }

  return {
    getCommand,
    getSingleEntity,
    getReadModelFromEntity,
    getEntitiesFromWorkflow,
    getFieldExampleData,
    getReadModelFromWorkflow,
    getEntitiesFromDescription
  }
}

export default usePrompts
